<main class="agpr-mad">
    <section class="agpr-mad-section" [attr.aria-label]="'Common.layout.main' | localize">
        @if (showHeader) {
            <header class="agpr-mad-header">
                <div class="agpr-mad-header-center">
                    <h2 class="agpr-mad-header-center-label">
                        @if (pageHeading$ | async) {
                            <span>{{ pageHeading$ | async }}</span>
                        }
                        @else {
                            <span>{{ 'Monitoring.search.monitoringSearchResults' | localize }}</span>
                        }
                        <span class="u-srOnly">{{ pageSRHeading$ | async | localize }}</span>
                    </h2>
                    <span class="agpr-mad-header-center-divider"></span>
                    <agpr-tabs-toggle
                        [id]="'mad_tabsToggle'"
                        [options]="viewModeOptions"
                        [ngModel]="selectedViewMode"
                        (ngModelChange)="viewModeChanged($event)"
                    ></agpr-tabs-toggle>
                </div>
                <div class="agpr-mad-header-filler"></div>
            </header>
        }

        <div class="agpr-mad-toolbar">
            <div class="agpr-mad-toolbar-date">
                <agpr-date-query-popup
                    class="agpr-mad-dateQueryPopup"
                    [id]="'mad_dateQueryPopup'"
                    [header]="'Monitoring.dateQueryDialog.header'"
                    [options]="dateFilterOptions$ | async"
                    [dateTypeOptions]="dateTypeFilterOptions$ | async"
                    [searchRange]="searchRange"
                    [(ngModel)]="startDateRange"
                    (ngModelChange)="dateRangeChanged($event)"
                ></agpr-date-query-popup>
            </div>
            <div class="agpr-mad-toolbar-filter">
                <div class="agpr-mad-filterDropdown">
                    <agpr-filter-dropdown
                        [id]="'mad_filterDropdown'"
                        [showQuickFilter]="true"
                        quickFilterPlaceholder="Monitoring.filtersLocalization.keywords.quickPlaceholder"
                        ariaLabel="Monitoring.filtersLocalization.ariaLabel"
                        [ariaDescribedBy]="'resultsFilters.chips'"
                    ></agpr-filter-dropdown>
                </div>
                <div class="agpr-mad-filterChips">
                    <agpr-filter-chips
                        #filterChipsComponent
                        [id]="'mad_filterChips'"
                    ></agpr-filter-chips>
                    @if (filterChipsComponent.chips.length > 1) {
                        <agpr-button
                            class="agpr-mad-filterClearButton"
                            [id]="'mad_filterClearButton'"
                            [style]="buttonTypes.icon"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Monitoring.result.filters.clear"
                            tooltipPosition="top"
                            (click)="clearFilters(true)"
                        ></agpr-button>
                    }
                    <agpr-button
                        [ngClass]="{
                            'agpr-mad-filterLockIcon--lock': filtersLocked,
                            'agpr-mad-filterLockIcon--unlock': !filtersLocked
                        }"
                        [id]="'filter.lock'"
                        [style]="buttonTypes.icon"
                        [icon]="filtersLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                        [tooltip]="filtersLocked ? 'Monitoring.result.filters.unlock' : 'Monitoring.result.filters.lock'"
                        tooltipPosition="top"
                        (click)="toggleFilterLock()"
                    ></agpr-button>
                </div>
            </div>
        </div>

        @if (isAccountSearch) {
            <agpr-message
                class="agpr-mad-banner"
                [severity]="messageSeverities.info"
            >
                {{ 'Monitoring.result.savedCoverageSearch.infoBanner'| localize }}
                <agpr-button
                    class="agpr-mad-banner-linkText"
                    [style]="buttonTypes.link"
                    (click)="searchNewContent()"
                >
                    {{ 'Monitoring.result.savedCoverageSearch.infoBanner.clickHere' | localize }}
                </agpr-button>
            </agpr-message>
        }

        <div class="agpr-mad-dashboard">
            @if (errorType === errorTypes.none) {
                <agpr-tabs [(selectedTabIndex)]="selectedTabIndex">
                    <agpr-tab
                        [id]="'mad_summaryTab'"
                        [heading]="'Monitor.MAD.tabs.summary'"
                        [icon]="'fa-regular fa-duotone fa-chart-tree-map'"
                    >
                        @if (selectedTabIndex === 0) {
                            <agpr-mad-summary
                                [loading]="refreshing$ | async"
                                (reportSeriesReady)="fulfillSeries($event)"
                                (reportSeriesChange)="updateSeries($event)"
                            ></agpr-mad-summary>
                        }
                    </agpr-tab>
                    <agpr-tab
                        [id]="'mad_sentimentTab'"
                        [heading]="'Monitor.MAD.tabs.sentiment'"
                        [icon]="'fa-regular fa-duotone fa-face-smile'"
                    >
                        @if (selectedTabIndex === 1) {
                            <agpr-mad-sentiment
                                (reportSeriesReady)="fulfillSeries($event)"
                                (reportSeriesChange)="updateSeries($event)"
                            ></agpr-mad-sentiment>
                        }
                    </agpr-tab>
                    <agpr-tab
                        [id]="'mad_socialTab'"
                        [heading]="'Monitor.MAD.tabs.social'"
                        [icon]="'fa-kit-duotone fa-agpr-engage'"
                    >
                        @if (selectedTabIndex === 2) {
                            <agpr-mad-social
                                [isAccountSearch]="isAccountSearch"
                                [isSavedCoverage]="isSavedCoverage"
                                (reportSeriesReady)="fulfillSeries($event)"
                                (reportSeriesChange)="updateSeries($event)"
                            ></agpr-mad-social>
                        }
                    </agpr-tab>
                    <agpr-tab
                        [id]="'mad_coverageInsightsTab'"
                        [heading]="'Monitor.MAD.tabs.coverageInsights'"
                        [icon]="'fa-kit-duotone fa-agpr-insights'"
                    >
                        <agpr-mad-coverage-insights></agpr-mad-coverage-insights>
                    </agpr-tab>
                </agpr-tabs>
            }
            @else {
                <div class="agpr-mad-errorBanner">
                    @switch (errorType) {
                        @case (errorTypes.filters) {
                            @if (filterError) {
                                <agpr-message [severity]="messageSeverities.warning">
                                    @if (filterError.filterTypes) {
                                        {{ 'Monitoring.result.filterError' | localize }}
                                        <ul class="agpr-mad-errorBanner-filtersErrorList">
                                            @for (filterType of filterError.filterTypes; track filterType) {
                                                <li>
                                                    {{ 'Monitoring.filtersLocalization.' + filterType | localize }}
                                                    <ng-container *ngIf="filterError.localizedInvalidValueMap">: {{ filterError.localizedInvalidValueMap.get(filterType).join(', ') }}</ng-container>
                                                </li>
                                            }
                                        </ul>
                                    }
                                    @else {
                                        {{ 'Monitoring.result.filterError.generic' | localize }}
                                    }
                                </agpr-message>
                            }
                        }
                        @case (errorTypes.queryLength) {
                            <agpr-message [severity]="messageSeverities.warning">
                                {{ 'Monitoring.result.error.queryLength' | localize }}
                            </agpr-message>
                        }
                        @case (errorTypes.discoverListNotExist) {
                            <agpr-message [severity]="messageSeverities.warning">
                                <p class="infoLink">
                                    {{ 'Monitoring.result.error.discoverListNotExist' | localize }}
                                    {{ 'Monitoring.result.error.discoverListNotExist.helpLinkText1' | localize }}
                                    <agpr-button
                                        class="agpr-mad-errorBanner-discoverListError-link"
                                        [style]="buttonTypes.link"
                                        label="Monitoring.result.error.discoverListNotExist.helpLinkText2"
                                        (click)="currentRoute.type === routeTypes.results ? updateSearch() : updateSavedSearch()"
                                    ></agpr-button>
                                    {{ 'Monitoring.result.error.discoverListNotExist.helpLinkText3' | localize }}
                                </p>
                            </agpr-message>
                        }
                        @case (errorTypes.unknown) {
                            <agpr-message [severity]="messageSeverities.warning">
                                {{ 'Monitoring.result.error.unknown' | localize }}
                            </agpr-message>
                        }
                    }

                    @if (hasInvalidDateRange) {
                        <agpr-message [severity]="messageSeverities.info">
                            {{ 'Monitoring.result.error.invalidDateRange' | localize: { startDate: validDateRangeStartDisplayString, endDate: validDateRangeEndDisplayString } }}
                        </agpr-message>
                    }
                </div>
            }
        </div>

        <agpr-action-bar [headingContext]="'Monitor.MAD.footer.headingContext' | localize">
            <ng-template #left>
                @switch (currentRoute.type) {
                    @case (routeTypes.adHocAnalyticsDashboard) {
                        <agpr-button
                            [id]="'mad_editSearchButton'"
                            label="Monitoring.result.editSearchButtonLabel"
                            [style]="buttonTypes.secondary"
                            (click)="updateSearch()"
                        ></agpr-button>
                    }
                    @case (routeTypes.topicAnalyticsDashboard) {
                        <agpr-button
                            [id]="'mad_refreshButton'"
                            label="Monitoring.result.refresh"
                            [loading]="refreshing$ | async"
                            [style]="buttonTypes.secondary"
                            (click)="refresh()"
                        ></agpr-button>
                    }
                    @case (routeTypes.subscriptionAnalyticsDashboard) {
                        <agpr-button
                            [id]="'mad_updateSubscription'"
                            label="Monitoring.result.updateSubscription"
                            [style]="buttonTypes.secondary"
                            (click)="gotoUpdateSubscription()"
                        ></agpr-button>
                    }
                }
            </ng-template>
            <ng-template #right>
                @switch (currentRoute.type) {
                    @case (routeTypes.topicAnalyticsDashboard) {
                        <agpr-button
                            [id]="'mentionSearchResult.EditTopicButton'"
                            label="Monitoring.result.editTopic"
                            [style]="buttonTypes.primaryB"
                            (click)="updateSavedSearch()"
                        ></agpr-button>

                        @if (topicDirty) {
                            <agpr-split-button
                                [id]="'mentionSearchResult.actions'"
                                label="Monitoring.save"
                                [style]="buttonTypes.primary"
                                [options]="saveActions"
                                [panelPositionY]="'top'"
                                [panelPositionX]="'right'"
                            ></agpr-split-button>
                        }
                    }
                    @case (routeTypes.adHocAnalyticsDashboard) {
                        @if (!isAccountSearch) {
                            <agpr-button
                                [id]="'mentionSearchResult.saveSearchAsTopic'"
                                label="Monitoring.result.saveSearchAsTopic"
                                [style]="buttonTypes.primary"
                                (click)="saveTopic()"
                            ></agpr-button>
                        }
                    }
                    @case (routeTypes.subscriptionAnalyticsDashboard) {
                        @if (mediaSubscription) {
                            @if (mediaSubscription.status !== mediaSubscriptionStatus.PAUSED) {
                                <agpr-button
                                    [id]="'mentionSearchResult.pauseButton'"
                                    label="pause"
                                    [style]="buttonTypes.primary"
                                    (click)="pause()"
                                ></agpr-button>
                            } @else {
                                <agpr-button
                                    [id]="'mentionSearchResult.activateButton'"
                                    label="activate"
                                    [style]="buttonTypes.primary"
                                    [tooltip]="activateButtonTooltip"
                                    [disabled]="!enableActiveButton"
                                    (click)="activate()"
                                ></agpr-button>
                            }
                        }
                    }
                }
            </ng-template>
        </agpr-action-bar>
    </section>
</main>
